/* Patch K&J 2026-09-24 (chantier SEO, lot 2) : le contenu des onglets est rendu dans le DOM
   (blocks/_tab.liquid, attribut hidden) au lieu d'un <template>. Au démarrage, chaque contenu est
   DÉPLACÉ (pas copié) dans le panneau ; on bascule ensuite l'attribut hidden. Les scripts du
   contenu s'exécutent donc une seule fois, au chargement, comme le reste de la page.
   Rétrocompatible avec l'ancien balisage <template> (vendor) au cas où un bloc ne serait pas à jour.
   Vendor d'origine : copie de template.innerHTML dans le panneau à chaque clic. */
class TabsContainer extends HTMLElement {
  #loadedScripts = new Set();

  constructor() {
    super();

    this.tabs = null;
    this.panel = null;
  }

  connectedCallback() {
    this.tabs = this.querySelectorAll('[data-ref="tab"]');
    this.panel = this.querySelector('[data-ref="tabs-panel"]');
    if (!this.tabs.length || !this.panel) return;

    this.tabs.forEach((tab) => {
      if (!tab._kjTabContent) {
        const content = tab.querySelector(':scope > [data-ref="tab-content"]');
        if (content) {
          content.hidden = true;
          this.panel.appendChild(content);
          tab._kjTabContent = content;
        }
      }

      tab.addEventListener('click', () => {
        this.#resetTabs();
        this.#selectTab(tab);
      });
    });

    this.#selectTab(this.tabs[0]);
  }

  #selectTab(tab) {
    if (tab._kjTabContent) {
      tab._kjTabContent.hidden = false;
      // Les sliders (Splide) initialisés dans un contenu masqué recalculent leur largeur.
      window.dispatchEvent(new Event('resize'));
    } else {
      // Ancien balisage vendor (<template>) : comportement d'origine.
      const template = tab.querySelector('template');
      if (template) {
        const tab_content = template.content.querySelector('[data-ref="tab-content"]');
        this.panel.innerHTML = tab_content.innerHTML;
        this.#activateScripts(this.panel);
      }
    }
    tab.classList.add('active');
  }

  #activateScripts(container) {
    for (const script of [...container.querySelectorAll('script')]) {
      const src = script.getAttribute('src');

      if (src) {
        if (this.#loadedScripts.has(src)) {
          script.remove();
          continue;
        }
        this.#loadedScripts.add(src);
      }

      const activeScript = document.createElement('script');

      for (const attr of script.attributes) {
        activeScript.setAttribute(attr.name, attr.value);
      }

      activeScript.textContent = script.textContent;
      script.replaceWith(activeScript);
    }
  }

  #resetTabs() {
    this.tabs.forEach((tab) => {
      tab.classList.remove('active');
      if (tab._kjTabContent) tab._kjTabContent.hidden = true;
    });
    // Ancien balisage : le panneau contenait une copie ; on ne vide que dans ce cas.
    if (![...this.tabs].some((t) => t._kjTabContent)) this.panel.innerHTML = '';
  }
}

if (!customElements.get('tabs-container')) {
  customElements.define('tabs-container', TabsContainer);
}
